import { useState } from 'react';
import cn from 'classnames';

import { PublicMainLawInfoItem } from './PublicMainLawInfoItem';
import { lawInfo } from '../constants/lawInfo';
import styles from './PublicMainLawInfo.module.scss';

interface IPublicMainLawInfoProps {
  className?: string;
}

export const PublicMainLawInfo = ({ className }: IPublicMainLawInfoProps) => {
  const [expanded, setExpanded] = useState(false);
  const onClick = () => setExpanded(!expanded);

  const renderArrowUp = () => (
    <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7704 6.71169C12.3658 7.09966 11.714 7.09555 11.3146 6.7025L6.96643 2.42349L2.61828 6.7025C2.21888 7.09555 1.56708 7.09966 1.16245 6.71169C0.757828 6.32371 0.753593 5.69055 1.153 5.2975L6.23378 0.297502C6.42721 0.107149 6.69108 4.76837e-07 6.96643 4.76837e-07C7.24177 4.76837e-07 7.50564 0.107149 7.69907 0.297502L12.7799 5.2975C13.1793 5.69055 13.175 6.32371 12.7704 6.71169Z"
        fill="#4B74B9"
      />
    </svg>
  );
  const renderArrowDown = () => (
    <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7704 0.288315C12.3658 -0.0996643 11.714 -0.0955513 11.3146 0.297502L6.96666 4.57651L2.61868 0.297502C2.21929 -0.0955513 1.56752 -0.0996643 1.16291 0.288315C0.7583 0.676294 0.754066 1.30945 1.15345 1.7025L6.23405 6.7025C6.42747 6.89285 6.69133 7 6.96666 7C7.24199 7 7.50585 6.89285 7.69927 6.7025L12.7799 1.7025C13.1793 1.30945 13.175 0.676294 12.7704 0.288315Z"
        fill="#4B74B9"
      />
    </svg>
  );

  const containerClassNames = cn(styles.Container, className);

  return (
    <div className={containerClassNames}>
      <h2 className={styles.Title}>Правовая информация</h2>
      <div className={styles.Items}>
        {lawInfo.slice(0, 4).map(({ id, name, text }) => (
          <PublicMainLawInfoItem key={id} className={styles.Item} name={name} text={text} expanded={expanded} />
        ))}
      </div>
      <div className={styles.Items}>
        {lawInfo.slice(4).map(({ id, name, text }) => (
          <PublicMainLawInfoItem key={id} className={styles.Item} name={name} text={text} expanded={expanded} />
        ))}
        <div className={styles.Item} />
      </div>
      <div className={styles.ButtonContainer}>
        {expanded ? (
          <button className={styles.Button} type="button" onClick={onClick}>
            Скрыть текст {renderArrowUp()}
          </button>
        ) : (
          <button className={styles.Button} type="button" onClick={onClick}>
            Показать полностью {renderArrowDown()}
          </button>
        )}
      </div>
    </div>
  );
};
